export interface JwtPayload {
  exp?: number;
  [claim: string]: unknown;
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const encodedPayload = token.split('.')[1];
    if (!encodedPayload) return null;

    const base64 = encodedPayload
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(encodedPayload.length / 4) * 4, '=');

    const decodedPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );

    return JSON.parse(decodedPayload) as JwtPayload;
  } catch {
    return null;
  }
}

export function isJwtExpiring(
  token: string,
  bufferSeconds: number,
  nowInMilliseconds = Date.now()
): boolean {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== 'number') return true;

  const expirationInMilliseconds = payload.exp * 1000;
  return expirationInMilliseconds <= nowInMilliseconds + bufferSeconds * 1000;
}
